<template>
 <div v-if="tiles">
        <h2 class="mb-5 mt-5">Selected images</h2>

        <v-row>
          <template v-for="card in tiles">
            <v-col
              v-if="card.type == 'Image'"
              :key="`images-${card.el}`"
              cols="4"
              min-height="100"
            >
              <div class="guage">
                <div class="guage__card">
                  <div
                    class="guage__card__avatar"
                    :style="{ backgroundImage: `url(${card.src})` }"
                  ></div>
                </div>
                <div class="guage__percent">
                  <div
                    class="guage__percent__bar"
                    :style="{ width: card.percentage }"
                  > <p>{{ card.count }}</p></div>
                </div>
              </div>
            </v-col>
          </template>
        </v-row>
      </div>
</template>

<script>


export default {
  name: "TilesImages",
  props: {
    tiles: {
      type: Array,
      default: null,
    },
  }
};
</script>
